import React from "react";
import "./style.css";
import bannerImage from "../../../assets/kb-sol/About-Us-Banner-01.jpg"
import founderImage from "../../../assets/kb-sol/Achille-new.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function AboutUs() {
  return (

    // <div className="yellowbg flex flex-wrap  mx-5">
     <div className="flex flex-wrap mx-2  sm:mx-5">
      <div className="hidden banner-wrapper mt-8 sm:flex sm:w-full sm:relative">

        <div
          className="hidden sm:flex sm:bg-black rounded-2xl"
          style={{ width: "100%", minHeight: "500px" }}
        >
          <img
            src={bannerImage}
            effect="blur"
            className="hidden sm:flex  bannerImage rounded-2xl"
            alt="Banner Image"
            width="100%"
            style={{ height: "100%" }}
          />
          <img
            src={founderImage}
            effect="blur"
            className="hidden sm:flex   aboutFounder "
            alt="Founder Image"
            width="20%"
            style={{ height: "40%" }}
          />
        </div>
      </div>
      <div className="flex text-center flex-wrap mt-16 sm:mt-0">
        <div className="self-center text-left w-full">
          <div className="self-center text-left w-full main-content p-8 md:p-12 lg:p-20">
            <p className="pb-4 w-2/12 flex">
              <h2 className="text-2xl pinkhighlight">&nbsp;OUR MISSION&nbsp;</h2>
            </p>
            <p className="py-1.5">
            At SyncMama, we get it—you’re a creator, too. Whether you’re making films, ads, podcasts, games, or anything in between, you need music that elevates your story, fits your budget, and clears all the legal hurdles. But here’s the thing: every time you choose music, you’re not just picking a sound. You’re choosing a system.
            </p>
            <p className="py-1.5">
            The ‘royalty-free’ model, where composers are bought out, prohibited from registering their works with collecting societies, and left to earn a trickle of revenue from streaming platforms—platforms never designed for background or production music. It’s not sustainable. It doesn’t nurture talent. And it certainly doesn’t reward the creativity it relies on.
            </p>
            <p className="py-1.5">
            And here’s the truth no one tells you: great composers don’t work for one-time fees. The most talented creators—those who bring emotion, nuance, and depth to your visuals—don’t sign away their rights and walk away. They work in systems that respect their craft and pay them fairly over time. That’s exactly what SyncMama is built for:
            </p>
            <p className="py-1.5">
            <ul className="list-disc list-inside space-y-2">
              <li>Composers keep ownership of their work</li>
              <li>We handle all the royalty reporting behind the scenes</li>
              <li>You get a <b>clear license in your name</b> —— global, perpetual, and airtight</li>
            </ul>
            </p>
            <p className="py-1.5">
            And you? You pay once and use your production forever. No royalties owed down the line. But under the hood, SyncMama ensures that artists still get paid fairly through their collecting societies. It’s smarter, cleaner, and more ethical—and you’re better protected too.
            </p>

            <p className="pb-4 pt-6 w-3/12 flex">
              <h2 className="text-2xl pinkhighlight">&nbsp;SYNC DIFFERENT!&nbsp;</h2>
            </p>
            <p className="py-1.5">
              We’re not just another music licensing site. Mama was created by people who’ve spent decades fighting for composer rights, running publishing companies, and working with the biggest talents in the industry. We’ve seen how “royalty-free” models chip away at creators’ livelihoods. So we built the alternative.
            </p>
            <p className="py-1.5">
              <b>Here, music licensing works for everyone: it’s fast and simple for video creators, fair and transparent for music creators.
            </b></p>
            <p className="py-1.5">
              Choosing Mama means supporting the kind of music industry we all want to see—where creativity is valued, not exploited. Supporting talent shouldn’t be complicated. It should be built into the system, a system that respects creativity—yours and theirs. SyncMama.
            </p>
            <br />
            <br />

            <p className="pink name">Achille Forler</p>
            <i className="black name">Founder</i>
          </div>
        </div>
      </div>
    </div>
  );
}